import { useQuery } from "@tanstack/react-query";

import type { InvoiceSummary } from "~/shared/schemas/invoice-schema.ts";
import { invoiceSummarySchema } from "~/shared/schemas/invoice-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

export const fetchInvoiceSummary = async (
	signal?: AbortSignal,
): Promise<InvoiceSummary | null> => {
	try {
		const resp = await getAndValidate(
			apiRoutes.GETCUSTOMERINVOICESUMMARY,
			invoiceSummarySchema,
			{ signal },
		);
		if (resp.success) {
			return resp.data;
		}

		console.error(`Failed to fetch invoice summary:`, resp.error);
		return null;
	} catch (error) {
		console.error(`Failed to fetch invoice summary:`, error);
		return null;
	}
};

export const useGetPaymentSummary = () => {
	const { data, isLoading, error } = useQuery({
		queryKey: ["invoice-summary"],
		queryFn: ({ signal }) => fetchInvoiceSummary(signal),
		staleTime: 0,
		gcTime: 0,
	});

	return {
		summary: data ?? {
			pastDueAmount: {
				count: 0,
				sum: 0,
			},
			dueSoonAmount: {
				count: 0,
				sum: 0,
			},
			outstandingBalance: {
				count: 0,
				sum: 0,
			},
		},
		isLoading,
		error: error,
	};
};
